import firebaseService from 'Services/firebaseService';
import history from '../../history';
import * as types from './types';

export function submitLoginWithFireBase({ email, password, returnPath }) {
  return dispatch =>
    firebaseService.auth &&
    firebaseService.auth
      .signInWithEmailAndPassword(email, password)
      .then(response => firebaseService.getUserData(response.user.uid))
      .then(user => {
        if (returnPath) {
          history.push(`${returnPath}`);
        }
        return dispatch({
          type: types.SET_USER_DATA,
          payload: user,
        });
      })
      .catch(error => {
        return dispatch({
          type: types.LOGIN_ERROR,
          payload: error,
        });
      });
}

/**
 * Logout
 */
export function logoutUser({ returnPath }) {
  return dispatch => {
    firebaseService.signOut().then(() => {
      dispatch({
        type: types.USER_LOGGED_OUT,
      });
      dispatch({
        type: types.REMOVE_USER_DATA,
      });

      if (returnPath) {
        history.push(`${returnPath}`);
      }
    });
  };
}

/**
 * Password Reset
 */
export function passwordReset({ email }) {
  return dispatch => {
    firebaseService
      .resetPassword(email)
      .then(res => {
        return dispatch({
          type: types.PASSWORD_RESET,
          payload: res,
        });
      })
      .catch(error => {
        console.warn('Password reset connection error: ', error);
      });
  };
}

export function registerWithFirebase(model) {
  const { email, password, returnPath } = model;

  let userModel;

  return dispatch =>
    firebaseService.auth &&
    firebaseService.auth
      .createUserWithEmailAndPassword(email, password)
      .then(response => {
        // we'll have to bring verification back with free version
        // or maybe only for free registration
        //response.user.sendEmailVerification();
        userModel = {
          ...model,
          uid: response.user.uid,
        };

        // Create in DB
        return firebaseService.createUserData(userModel);
      })
      .then(() => {
        dispatch({
          type: types.SET_ACTIVE_MODAL,
          payload: 'none',
        });

        if (returnPath) {
          history.push(`${returnPath}`);
        }
        // Initial navigation
        return dispatch({
          type: types.SET_USER_DATA,
          payload: userModel,
        });
      })
      .catch(error => {
        // firebase saves human readable message in message
        // anything else will be caught as just error
        const _error = error.message || error;
        dispatch({
          type: types.REGISTER_ERROR,
          payload: _error,
        });
        // This is important so this action can be awaited on checkout
        throw new Error(_error);
      });
}
